import * as v from "valibot";

import { rpcContract } from "../rpc";

/**
 * Schema for user preferences settings.
 * Add new preference fields here as the system evolves.
 */
export const userPreferencesSettingsSchema = v.object({
  chatDisplayName: v.optional(v.string()),
});

export type UserPreferencesSettings = v.InferOutput<typeof userPreferencesSettingsSchema>;

export const updateUserPreferencesResultSchema = v.object({
  settings: userPreferencesSettingsSchema,
});

export type UpdateUserPreferencesResult = v.InferOutput<typeof updateUserPreferencesResultSchema>;

export const updateUserPreferencesRpcContract = rpcContract({
  paramsSchema: v.object({
    settings: v.partial(userPreferencesSettingsSchema),
  }),
  resultSchema: updateUserPreferencesResultSchema,
  name: "update-user-preferences",
});

export type UpdateUserPreferencesParams = v.InferOutput<(typeof updateUserPreferencesRpcContract)["paramsSchema"]>;
